import { MapPin, Car, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const ZONES = [
  {
    name: "Boulogne-Billancourt",
    accent: "#00a86b",
    badge: "Siège",
  },
  {
    name: "Porte de Saint-Cloud",
    accent: "#1368ce",
    badge: "Paris 16ᵉ",
  },
  {
    name: "Porte d'Auteuil",
    accent: "#8b5cf6",
    badge: "Paris 16ᵉ",
  },
  {
    name: "Place d'Italie",
    accent: "#FF8C42",
    badge: "Paris 13ᵉ",
  },
];

const HIGHLIGHTS = [
  { icon: Car, title: "Variété de situations", desc: "De la conduite résidentielle aux grands axes parisiens : nos élèves s'adaptent à tous les contextes." },
  { icon: Sparkles, title: "Préparation à l'examen", desc: "Les zones d'examen sont intégrées dès les premières leçons pour vous mettre en confiance le jour J." },
];

export default function ELearning() {
  return (
    <section id="elearning" className="anchor-offset bg-[#f8faff] py-24 md:py-32" data-testid="zones-section">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <div className="text-[#FF8C42] font-headings font-bold text-sm uppercase tracking-[0.2em]">Nos zones de conduite</div>
            <h2 className="mt-3 font-headings font-black text-4xl md:text-6xl tracking-tight leading-[1.05] text-[#1a2332]">
              Conduisez à <span className="text-[#FF8C42]">Paris</span>.
            </h2>
            <p className="mt-6 text-[#5b6577] text-lg max-w-xl">
              Nos moniteurs sont présents à Paris au départ de <strong className="text-[#1a2332]">Porte de Saint-Cloud (16ᵉ)</strong>, <strong className="text-[#1a2332]">Porte d&apos;Auteuil (16ᵉ)</strong>, <strong className="text-[#1a2332]">Boulogne-Billancourt</strong> et <strong className="text-[#1a2332]">Place d&apos;Italie (13ᵉ)</strong>.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3">
              {ZONES.map((z) => (
                <div key={z.name} className="bg-white rounded-xl p-4 border border-black/5" data-testid={`zone-${z.name.toLowerCase().replace(/[^a-z]/g, '-')}`}>
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center text-white" style={{ backgroundColor: z.accent }}>
                    <MapPin className="w-4 h-4" />
                  </div>
                  <div className="mt-3 font-headings font-bold text-[#1a2332]">{z.name}</div>
                  <div className="text-[10px] uppercase tracking-wide font-headings font-bold mt-0.5" style={{ color: z.accent }}>{z.badge}</div>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <Link to="/reservation" data-testid="cta-reservation-zones"
                className="inline-flex items-center gap-2 bg-[#1a2332] hover:bg-[#FF8C42] text-white font-headings font-bold rounded-xl px-6 py-3.5 text-sm transition-colors shadow-lg">
                Choisissez votre point de départ
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-4">
            {HIGHLIGHTS.map((f, idx) => {
              const Icon = f.icon;
              return (
                <div key={f.title} className="bg-white rounded-2xl border border-black/5 shadow-sm p-6 flex gap-4 items-start" data-testid={`zone-highlight-${idx}`}>
                  <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${idx === 1 ? "bg-[#FF8C42]/10 text-[#FF8C42]" : "bg-[#00a86b]/10 text-[#00a86b]"}`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <div>
                    <div className="font-headings font-black text-[#1a2332]">{f.title}</div>
                    <p className="mt-1 text-sm text-[#5b6577] leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
